import React, { useEffect, useState } from "react";
import {
  Container, Box, Typography,
  // Divider, Menu, MenuItem, ListItemIcon, Dialog, DialogContent, CircularProgress, IconButton, Collapse, Button, Skeleton, Stack,
  Slide, Link, AppBar, Breadcrumbs, Chip, Grid,
  // Chip, Card, CardContent, CardActions, Button, Link,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { dataConstants } from '../../src/constants';
import _getWideScreenerMetrics from "../../lib/screener/_getScreenerMetrics";
import getPageMetaTags from "../../lib/meta/_getMetaTags";
// import getSectors from "../../lib/sectors/_getSectors";
// import TableColumnsDrawer from "../../src/components/Screener/TableDrawer";
// import ScreenerTablePro from "../../src/components/Screener/ScreenerTablePro";
// import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import useAuth from "../../src/hook/auth";
import _getScreenerPreset from "../../lib/screener/userOperations/_getScreen";
import _updateScreenerPreset from "../../lib/screener/userOperations/_updateScreen";
import _renameScreenerPreset from "../../lib/screener/userOperations/_renameScreen";
import _deleteScreenerPreset from "../../lib/screener/userOperations/_deleteScreen";
// import PresetMenu from "../../src/components/Screener/PresetMenu";
// import SaveScreener from "../../src/components/Screener/SaveScreener";
// import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
// import SaveAltRoundedIcon from '@mui/icons-material/SaveAltRounded';
// import PremiumBanner from "../../src/components/Pricing/PremiumBanner";
// import { isMobile } from "../../src/helpers/deviceDetect";
// import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { downloadCSV } from "../../src/utils/helpers";
// import MoreVertIcon from '@mui/icons-material/MoreVert';
import _getWideScreenerMetricsCount from "../../lib/screener/_getScreenerMetricsCount";
// import MultiFilterAutocomplete from "../../src/components/Screener/SearchQuery";
import _getScreens from "../../lib/screener/userOperations/_getScreens";
// import QueryBuilder from "../../src/components/Screener/QueryBuilder";
// // import QueryExamples from "../../src/components/Screener/QueryExamples";
// import ScreenPresets from "../../src/components/Screener/ScreenPresets";
// import ManageColumnsDialog from "../../src/components/Screener/ManageTableColumns.js";
// import TextareaComponent from "../../src/components/Screener/QueryAutoSuggest";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
// import DriveFileRenameOutlineRoundedIcon from '@mui/icons-material/DriveFileRenameOutlineRounded';
// import RenameScreener from "../../src/components/Screener/RenameScreener";
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import { useRouter } from "next/router";
import { getFormula } from "../../src/components/Screener/QueryBuilder/typeahead.util";
// import AddRoundedIcon from '@mui/icons-material/AddRounded';
import ViewColumnRoundedIcon from '@mui/icons-material/ViewColumnRounded';

import Image from 'next/image'

const { SCREENER_OPTIONS: options, DEFAULT_TBL_COLS } = dataConstants;

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    // color: theme.palette.primary.main,
    color: "#2a2d64",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    // backgroundColor: theme.palette.primary.main,
    backgroundColor: "#2a2d64",
    fontWeight: 600,
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    padding: '5px 15px',
  },
}));

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  return {
    height: '24px',
    backgroundColor: 'transparent',
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      // backgroundColor: theme.palette.background.primary_light,
      // boxShadow: theme.shadows[1],
      icon: {
        color: theme.palette.background.primary,
      }
    },
    '&:active': {
      boxShadow: theme.shadows[1],
    },
  };
});

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const mainHeadCols = [
  { "name": "", "colSpan": "3", "includeCols": ["ticker", "shortName"] },
  { "name": "Fundamentals", "colSpan": "2", "includeCols": ["MKTCAP", "REV_TTM"] },
  { "name": "Returns", "colSpan": "2", "includeCols": ["PCHG__180"] },
  { "name": "Valuation", "colSpan": "3", "includeCols": ["PE", "PS", "MKTEBT"] },
  { "name": "Growth", "colSpan": "3", "includeCols": ["ROE", "REV_TTM__PCHG_1Y", "NETINC_TTM__PCHG_1Y"] },
  { "name": "Income Statement", "colSpan": "0", "includeCols": [] },
  { "name": "Balance Sheet", "colSpan": "0", "includeCols": [] },
  { "name": "Cashflow Statement", "colSpan": "0", "includeCols": [] },
  { "name": "Statistics", "colSpan": "0", "includeCols": [] },
  { "name": "Operations", "colSpan": "0", "includeCols": [] },
  { "name": "", "colSpan": "0", "includeCols": ["delete"] }
]

const defaultCols = [
  { "label": "Fundamentals", "name": "Ticker", "tooltip": "Ticker", "field": "ticker", "urlField": "ticker", "class": "text-left", sortFunc: (a, b) => a.localeCompare(b) },
  { "label": "Fundamentals", "name": "Name", "tooltip": "Name", "field": "tickername", "class": "td-color", "urlField": "ticker" },
  { "label": "Fundamentals", "name": "Sector", "field": "sector", "class": "text-left", "isSectorValue": false, "isPct": false, "mult": 1, "tooltip": "Sector" },
  { "label": "Fundamentals", "name": "Market Cap", "field": "MKTCAP", "class": "sorted", "isSectorValue": true, "isPct": false, "mult": 1, "tooltip": "Market Capital" },
  { "label": "Income Statement", "name": "Revenues TTM", "field": "REV_TTM", "class": "text-right", "isSectorValue": true, "isPct": false, "mult": 1, "tooltip": "Net sales" },
  { "label": "Returns", "name": "1W Pct", "field": "PCHG__7", "class": "text-right", "isSectorValue": false, "isPct": true, "mult": 100, "tooltip": "1-Week Stock Price Percent Change" },
  { "label": "Returns", "name": "1M Pct", "field": "PCHG__30", "class": "text-right", "isSectorValue": false, "isPct": true, "mult": 100, "tooltip": "1-Month Stock Price Percent Change" },
  { "label": "Returns", "name": "1Y Pct", "field": "PCHG__365", "class": "text-right", "isSectorValue": false, "isPct": true, "mult": 100, "tooltip": "1-Year Percent Change in Stock Price" },
  { "label": "Valuation", "name": "PE", "field": "PE", "class": "text-right", "isSectorValue": false, "isPct": false, "mult": 1, "tooltip": "Price to Earnings Ratio" },
  { "label": "Valuation", "name": "PS", "field": "PS", "class": "text-right", "isSectorValue": false, "isPct": false, "mult": 1, "tooltip": "Price to Sales Ratio" },
  { "label": "Valuation", "name": "ROE", "field": "ROE", "class": "text-right", "isSectorValue": false, "isPct": true, "mult": 1, "tooltip": "Return on Equity" },
  { "label": "Growth", "name": "Rev 3Y Grw", "field": "REV_TTM__PCHG_3Y", "class": "text-right", "isSectorValue": false, "isPct": true, "mult": 1, "tooltip": "Reveue Grw in past 3-Years" },
  { "label": "Returns", "name": "Drawdowns", "field": "DRAWDN", "class": "text-right", "isSectorValue": false, "isPct": true, "mult": 1, "tooltip": "DrawDown" }
]
// const ScreenerRefresh = styled(Switch)(({ theme }) => ({
//   padding: 8,
//   '& .MuiSwitch-track': {
//     borderRadius: 22 / 2,
//     '&:before, &:after': {
//       content: '""',
//       position: 'absolute',
//       top: '50%',
//       transform: 'translateY(-50%)',
//       width: 16,
//       height: 16,
//     },
//     '&:before': {
//       backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
//         theme.palette.getContrastText(theme.palette.primary.main),
//       )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
//       left: 12,
//     },
//     '&:after': {
//       backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
//         theme.palette.getContrastText(theme.palette.primary.main),
//       )}" d="M19,13H5V11H19V13Z" /></svg>')`,
//       right: 12,
//     },
//   },
//   '& .MuiSwitch-thumb': {
//     boxShadow: 'none',
//     width: 16,
//     height: 16,
//     margin: 2,
//   },
// }));


// const createSentence = (marketCap, conditions) => {
//   let sentence = `Filtered by`;

//   marketCap.forEach(cap => {
//     sentence += `, <b>${cap}</b>`;
//   });
//   if (conditions?.length > 0) {
//     sentence += ` and `;
//   }

//   conditions.forEach((condition, index) => {
//     let cond = '';
//     switch (condition.condition) {
//       case 'GREATER_THAN':
//         cond = `<b>${condition.code} greater than ${condition.value}</b>`;
//         break;
//       case 'BETWEEN':
//         cond = `<b>${condition.code} between ${condition.value} and ${condition.tovalue}</b>`;
//         break;
//       case 'LESS_THAN':
//         cond = `<b>${condition.code} less than ${condition.value}</b>`;
//         break;
//       default:
//         break;
//     }

//     sentence += `${cond}`;

//     if (index !== conditions.length - 1) {
//       sentence += ` and `;
//     }
//   });

//   return sentence;
// };

// const createSentence = (marketCap, conditions, setConditions, setSelectedOptions, setMarketCap, setUseHook) => {
//   const chips = [];

//   // Add marketCap chips
//   marketCap.forEach((cap) => {
//     chips.push(
//       <Chip
//         sx={{
//           height: '24px',
//           margin: '2px',
//           lineHeight: '22px',
//           backgroundColor: '#f0f1f4',
//           border: '1px solid rgba(0, 0, 0, 0.1)',
//           borderRadius: '4px',
//           boxSizing: 'content-box',
//           outline: '0px',
//           overflow: 'hidden',
//           color: '#020B4A',
//           fontSize: '12px',
//         }}
//         deleteIcon={<CloseRoundedIcon />}
//         size="small"
//         key={cap}
//         label={cap}
//         variant="outlined"
//         onDelete={() => {
//           const index = marketCap.indexOf(cap);
//           marketCap.splice(index, 1);
//           setMarketCap([...marketCap]); // Update state or re-render component
//         }}
//       />
//     );
//   });

//   // Add "and" separator
//   if (marketCap.length > 0 && conditions.length > 0) {
//     chips.push(<Chip key="and" label="and" sx={{ backgroundColor: 'transparent', color: '#020B4A', px: 0 }} />);
//   }

//   // Add conditions chips
//   conditions.forEach((condition) => {
//     let label = '';
//     switch (condition.condition) {
//       case 'GREATER_THAN':
//         label = `${condition.code} greater than ${condition.value}`;
//         break;
//       case 'BETWEEN':
//         label = `${condition.code} between ${condition.value} and ${condition.tovalue}`;
//         break;
//       case 'LESS_THAN':
//         label = `${condition.code} less than ${condition.value}`;
//         break;
//       default:
//         break;
//     }

//     chips.push(
//       <Chip
//         sx={{
//           height: '24px',
//           margin: '2px',
//           lineHeight: '22px',
//           backgroundColor: '#f0f1f4',
//           border: '1px solid rgba(0, 0, 0, 0.1)',
//           borderRadius: '4px',
//           boxSizing: 'content-box',
//           outline: '0px',
//           overflow: 'hidden',
//           color: '#020B4A',
//           fontSize: '12px',
//         }}
//         deleteIcon={<CloseRoundedIcon />}
//         size="small"
//         key={label}
//         label={label}
//         variant="outlined"
//         onDelete={() => {
//           const index = conditions.indexOf(condition);
//           conditions.splice(index, 1);
//           setConditions([...conditions]); // Update state or re-render component
//           setSelectedOptions([...conditions])
//           setUseHook(true)
//         }}
//       />
//     );

//     // Add "and" separator
//     if (conditions.indexOf(condition) !== conditions.length - 1) {
//       chips.push(<Chip key={`${label}-and`} label="and" sx={{ backgroundColor: 'transparent', color: '#020B4A', px: 0 }} />);
//     }
//   });

//   // Return the chips wrapped in a sentence
//   return (
//     <>
//       <Typography variant="subtitspanle2" gutterBottom>{`${chips.length <= 0 ? '–' : `Filtered by: `}`}</Typography>
//       {chips.map((chip) => (
//         <span key={chip.key}>&nbsp;{chip}</span>
//       ))}
//     </>
//   );
// };

// const baseValue = {};

// const settings = (baseline = baseValue, payload = {}) => ({
//   ...baseline,
//   ...payload,
// });


// const getTheme = (baseline = baseValue, payload = {}) => {
//   const { type, chart_settings, series_settings = {}, icon } = payload || {};

//   const { pallete, gradient } = payload.pallete ? JSON.parse(payload.pallete) : {};

//   return {
//     type,
//     chartSettings: settings(undefined, JSON.parse(chart_settings)),
//     pallete,
//     gradient,
//     seriesSettings: JSON.parse(series_settings),
//     icon,
//   };
// };

const ScreenerPage = (props) => {
  const router = useRouter();
  const { user, logout } = useAuth()
  const { reloadUserInfo } = user || {}
  const isPremium = reloadUserInfo?.customAttributes && (JSON.parse(reloadUserInfo?.customAttributes)?.userType === "PREMIUM" || JSON.parse(reloadUserInfo?.customAttributes)?.userType === "PROFESSIONAL") ? true : false;
  const {
    _screenerMetrics, _screenerMetricsCount, screens, themeMode,
    // chart_theme, toggleColorMode, sectors
  } = props || {}
  const [screenerMetrics, setScreenerMetrics] = React.useState(_screenerMetrics ?? []);
  // const [tableMetrics, setTableMetrics] = React.useState([]);
  const [estimatedResults, setEstimatedResults] = React.useState(_screenerMetricsCount ?? null);
  const [showingResults, setShowingResults] = React.useState(_screenerMetrics?.length);
  // const estimatedResults = tableMetrics.length ?? screenerMetrics.length
  // const { getThemes } = chart_theme || {};
  // const [themes, setThemes] = React.useState(getThemes && getThemes.map(d => getTheme(undefined, d)))
  // const [selectedInfo, setSelectedInfo] = React.useState(null);
  const [isLoading, setLoading] = React.useState(false);
  const [isTableLoading, setTableLoading] = React.useState(false);
  const [saveLoading, setSaveLoading] = React.useState(false);
  // const [marketCap, setMarketCap] = useState(['SMALL_CAP', 'MID_CAP', 'LARGE_CAP', 'MEGA_CAP'])
  // const [conditions, setConditions] = useState([]);
  // const [screenWidth, setScreenWidth] = useState("lg");
  const [first, setFirst] = useState(100);
  const [offset, setOffset] = useState(0);
  // const [selectedOptions, setSelectedOptions] = useState([]);
  // const [useHook, setUseHook] = useState(false);
  const [userPresets, setUserPresets] = useState(screens ?? []);
  const [userUpdatedPreset, setUserUpdatedPreset] = useState(null);
  const [userDeletedPreset, setUserDeletedPreset] = useState(null);

  const [anchorEl, setAnchorEl] = React.useState(null);
  // const [selectedIndex, setSelectedIndex] = React.useState(1);
  // const [defaultScreenerTableCols, setDefaultScreenerTableCols] = useState(DEFAULT_TBL_COLS)
  // const [selected, setSelected] = useState([]);
  // const [selectedRows, setSelectedRows] = useState([]);

  const [tableCols, setTableCols] = React.useState(defaultCols);
  // const [newTableCols, setNewTableCols] = React.useState([]);
  const [message, setMessage] = React.useState(null);
  const [banner, setBanner] = React.useState(false);
  const [activePresetName, setActivePresetName] = React.useState('');
  const [activePresetDesc, setActivePresetDesc] = React.useState('');
  const [activePresetCode, setActivePresetCode] = React.useState('');
  const [presetCriteria, setPresetCriteria] = React.useState(null);
  const [anchorMenuEl, setAnchorMenuEl] = React.useState(null);
  const openPremiumMenu = Boolean(anchorMenuEl);
  // const [mounted, setMounted] = React.useState(false)
  const [formula, setFormula] = useState([]);
  const [andor, setAndor] = useState('AND');
  // const [inputText, setInputText] = useState("2 * Price/Earnings + Revenues, TTM, 1-Year % Chg < 0.00002 AND\nReturn on Assets > 1 OR 2 * Price/Earnings < 0.0002 OR Return on Assets > 1");
  const [inputText, setInputText] = useState("");
  const [columnGroups, setColumnGroups] = useState([])
  const [renameDialog, setRenameDialog] = React.useState(false);

  const logoutUser = () => {
    logout();
    router.push({
      pathname: '/auth',
      query: { from: router.asPath },
    })
  }

  const handleRenameOpen = () => {
    // handleMenuClose()
    if (isPremium) {
      setRenameDialog(!renameDialog);
    } else {
      setBanner(true);
    }
  };

  const handleRenameClose = () => {
    setRenameDialog(false);
  };

  const handleMenuClick = (event) => {
    setAnchorMenuEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorMenuEl(null);
  };

  // const handleBannerOpen = () => {
  //   setBanner(true);
  // };

  const handleBannerClose = () => {
    setBanner(false);
  };

  // const handleChange = (event) => {
  //   setChecked(event.target.checked);
  // };

  // const open = Boolean(anchorEl);

  // const handlePresetList = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleMenuItemClick = (event, index) => {
  //   setSelectedIndex(index);
  //   setAnchorEl(null);
  // };

  // let prevConditions = React.useRef(conditions);
  // let prevScreenerMetrics = React.useRef(screenerMetrics);

  // const handleClick = (event) => {
  //   setNewTableCols(tableCols);
  //   setAnchorEl(event.currentTarget);
  // };

  const handleClose = () => {
    // setTableCols(newTableCols);
    if (anchorEl) {
      anchorEl.focus();
    }
    setAnchorEl(null);
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setTableCols(prevValue => {
      const newValue = [...prevValue];
      const [itemToMove] = newValue.splice(oldIndex, 1);
      newValue.splice(newIndex, 0, itemToMove);
      return newValue;
    });
  };

  // const conditionObj = { code: "", condition: "", name: "", label: "", value: 0, tovalue: 100, }

  // const condition = Object.create(conditionObj);

  // const handleChildCheckbox = (subFilter) => {
  //   if (!selected.includes(subFilter.key)) {
  //     setSelected((prevSelected) => [...prevSelected, subFilter.key]);
  //     const newCondition = { ...conditionObj };
  //     newCondition.code = subFilter.key;
  //     newCondition.name = subFilter.name;
  //     newCondition.label = subFilter.label;
  //     newCondition.condition = "GREATER_THAN";
  //     setConditions((prevConditions) => [...prevConditions, newCondition]);
  //   } else {
  //     setSelected((prevSelected) =>
  //       prevSelected.filter((key) => key !== subFilter.key)
  //     );
  //     setConditions((prevConditions) =>
  //       prevConditions.filter(
  //         (condition) => condition.code !== subFilter.key
  //       )
  //     );
  //   }
  // };

  // const handleConditionDelete = (code) => {
  //   setConditions((prevConditions) =>
  //     prevConditions.filter((condition) => condition.code !== code)
  //   );
  // };

  // const handleTableCheckbox = (newTableRow) => {
  //   const field = newTableRow.field;
  //   if (!selectedRows.includes(field)) {
  //     setSelectedRows((prevSelected) => [...prevSelected, field]);
  //     setDefaultScreenerTableCols((prevTableRows) => [...prevTableRows, newTableRow]);
  //   } else {
  //     setSelectedRows((prevSelected) => prevSelected.filter((selectedField) => selectedField !== field));
  //     setDefaultScreenerTableCols((prevTableRows) => prevTableRows.filter((prevTableRow) => prevTableRow.field !== field));
  //   }
  // };

  // const handleTableChipDelete = (field) => {
  //   setDefaultScreenerTableCols((prevTableRows) =>
  //     prevTableRows.filter((prevTableRow) => prevTableRow.field !== field)
  //   );
  // };

  // const addToDefaultScreenerTableCols = (obj) => {
  //   setDefaultScreenerTableCols((prevTableCols) => [...prevTableCols, obj]);
  // };

  // const _setConditions = (code, newCondition) => {
  //   const updatedConditions = conditions.map(condition => {
  //     if (condition.code === code) {
  //       return { ...condition, ...newCondition }
  //     }
  //     return condition;
  //   })
  //   setConditions(updatedConditions)

  // }

  // const setNewCondition = (newCondition) => {
  //   setConditions(conditions?.concat(newCondition))
  // }

  // const getScreenersCount = async (capCat, _conditions) => {
  //   setLoading(true);
  //   const newCapCapt = capCat && JSON.stringify(capCat).replace(/\"/g, "");
  //   await _getWideScreenerMetricsCount(newCapCapt, _conditions ?? conditions).then((d) => {
  //     setEstimatedResults(d?.getWideScreenerMetricsCount)
  //     setLoading(false)
  //   }).catch((error) => {
  //     console.log(error);
  //   })
  // }

  // const getScreeners = async (capCat, _conditions, newCond, _first, _offset) => {
  //   setTableLoading(true);
  //   const newCapCapt = capCat && JSON.stringify(capCat).replace(/\"/g, "");
  //   // const metCount = await _getWideScreenerMetricsCount(newCapCapt, _conditions ?? conditions)
  //   // const offset = metCount?.getWideScreenerMetricsCount >= 100 ? _offset : 0;
  //   await _getWideScreenerMetrics(newCapCapt, _conditions ?? conditions, _first, _offset).then((d) => {
  //     setShowingResults(showingResults + d?.getWideScreenerMetrics?.length);
  //     if (newCond || useHook) {
  //       setScreenerMetrics(d?.getWideScreenerMetrics);
  //     } else {
  //       // Filter out duplicates
  //       // const existingData = [...screenerMetrics];
  //       // const existingIds = new Set(existingData.map((data) => data?.ticker));
  //       // const newData = d?.getWideScreenerMetrics?.filter((data) => !existingIds.has(data?.ticker));
  //       // setScreenerMetrics([...existingData, ...newData]);
  //       setScreenerMetrics([...screenerMetrics, ...d?.getWideScreenerMetrics]);
  //     }
  //     setTableLoading(false);
  //     setUseHook(false);
  //   }).catch((error) => {
  //     setTableLoading(false);
  //   });
  // };

  const getScreenersCount = async (andor, formula) => {
    if (formula?.length > 0) {
      setLoading(true);
      await _getWideScreenerMetricsCount(andor, formula).then((d) => {
        setEstimatedResults(d?.getWideScreenerMetricsCountV3)
        setLoading(false)
      }).catch((error) => {
        console.log(error);
      })
    }
  }

  const getScreeners = async (andor, formula) => {
    if (formula?.length > 0) {
      setTableLoading(true);
      await _getWideScreenerMetrics(andor, formula, first, offset).then((d) => {
        setShowingResults(showingResults + d?.getWideScreenerMetricsV3?.length);
        // if (newCond || useHook) {
        offset > 0 ?
          setScreenerMetrics(d?.message?.message ? { err: d?.message } : [...screenerMetrics, ...d?.getWideScreenerMetricsV3]) :
          setScreenerMetrics(d?.message?.message ? { err: d?.message } : d?.getWideScreenerMetricsV3);
        // } else {
        // setScreenerMetrics([...screenerMetrics, ...d?.getWideScreenerMetricsV3]);
        // }
        setTableLoading(false);
        // setUseHook(false);
      }).catch((error) => {
        setTableLoading(false);
      });
    }
  };

  // const plotTableRows = (newCond) => {
  //   // if (tableMetrics?.length !== estimatedResults) {
  //   //   setTableMetrics(screenerMetrics);
  //   // }
  //   // getScreeners(marketCap, conditions, newCond, first, offset)
  //   getScreeners(andor, formula)
  // }

  // React.useEffect(() => {
  //   setShowingResults(_screenerMetrics?.length)
  //   setScreenerMetrics(_screenerMetrics);
  //   // setTableMetrics(_screenerMetrics)
  // }, []);

  React.useEffect(() => {
    setShowingResults(screenerMetrics?.length)
    // setTableLoading(false);
    // async () => {
    //   setTableLoading(true);
    //   await sleep(1e3);
    //   setTableLoading(false);
    // }
  }, [screenerMetrics]);

  useEffect(() => {
    if (user?.accessToken) {
      _getScreens(user?.accessToken).then(data => setUserPresets(data?.getScreens ?? []));
    } else {
      _getScreens('').then(data => setUserPresets(data?.getScreens ?? []));
    }
  }, [user, userUpdatedPreset, userDeletedPreset])

  useEffect(() => {
    if (!user?.accessToken) {
      setUserPresets(screens ?? []);
    }
  }, [])

  const updatePreset = (screen_name, screen_desc) => {
    let textarea = typeof window !== 'undefined' && document?.getElementById('query-builder')
    let input_text = (textarea?.value)
    // let filters = JSON.stringify(conditions)?.replace(/"/g, '\\"');
    let columns = JSON.stringify(tableCols?.filter(item => item !== null && item !== undefined)?.map(item => item?.field)).replace(/"/g, "'");

    if (!user?.accessToken) {
      throw new Error('Missing user access token');
    }

    if (!screen_name) {
      throw new Error('Missing preset name');
    }

    if (input_text !== "") {
      setSaveLoading(true)
      const _options = options.sort((a, b) => b.shortName.length - a.shortName.length);
      for (var i = 0; i < _options.length; i++) {
        var entry = _options[i];
        var shortName = entry.shortName;
        var aggCode = entry.aggCode;
        var regex = new RegExp("\\b" + shortName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + "\\b", "gi");
        input_text = input_text.replace(regex, "`" + aggCode + "`");
      }
      _updateScreenerPreset(screen_name, screen_desc, andor, getFormula(input_text, _options), input_text, columns, user?.accessToken)
        .then(response => {
          setUserUpdatedPreset(response?.updateScreen?.screen_name);
          setSaveLoading(false)
        })
        .catch(error => {
          console.error('Error updating preset:', error);
          alert('An error occurred while updating the preset. Please try again later.');
          setSaveLoading(false)
        });
    }
  }

  const renamePreset = (screen_name, screen_desc, code) => {
    if (!user?.accessToken) {
      throw new Error('Missing user access token');
    }

    if (!screen_name) {
      throw new Error('Missing preset name');
    }

    _renameScreenerPreset(screen_name, screen_desc, code, user?.accessToken)
      .then(response => {
        setUserUpdatedPreset(response?.renameScreen?.screen_name);
        setActivePresetName(response?.renameScreen?.screen_name && activePresetName === screen_name ? response?.renameScreen?.screen_name : screen_name)
        setActivePresetDesc(screen_desc)
      })
      .catch(error => {
        console.error('Error renaming preset:', error);
        alert('An error occurred while renaming the preset. Please try again later.');
      });
  }

  const deletePreset = async (screen_code) => {
    try {
      if (!user?.accessToken || !screen_code) {
        throw new Error('Missing user access token or preset name');
      }
      const response = await _deleteScreenerPreset(screen_code, user.accessToken);
      setUserDeletedPreset(response?.deleteScreenerPreset?.status);
      if (user?.accessToken) {
        _getScreens(user?.accessToken).then(data => setUserPresets(data?.getScreens));
      }
    } catch (error) {
      console.error('Error deleting preset:', error);
      alert('An error occurred while deleting the preset. Please try again later.');
    }
  };

  // React.useEffect(() => {
  //   if (prevConditions !== null && prevConditions !== conditions && useHook) {
  //     getScreeners(marketCap, conditions, true)
  //   }
  // }, [conditions, useHook]);

  // const csvHeader = [
  //   { key: 'ticker', label: "Ticker" },
  //   { key: 'tickername', label: "Name" },
  //   { key: 'MKTCAP', label: "Mkt Cap" },
  //   { key: 'PCHG__7', label: "Price %, 1W" },
  //   { key: 'PCHG__30', label: "Price %, 1M" },
  //   { key: 'PCHG__180', label: "Price %, 6M" },
  //   { key: 'PCHG__365', label: "Price %, 1Y" },
  //   { key: 'RETURNS__1095', label: "Returns, 3Y" },
  //   { key: 'REV_TTM', label: "Revenue" },
  //   { key: 'NETINC_TTM', label: "Net Inc" },
  //   { key: 'EBT', label: "MktCap/EBT" },
  //   { key: 'REV_TTM__PCHG_1Y', label: "Rev 1-Yr" },
  //   { key: 'NETINC_TTM__PCHG_1Y', label: "Inc 1-Yr" },
  //   { key: 'PE', label: "P/E" },
  //   { key: 'PS', label: "P/S" },
  //   { key: 'ROE', label: "ROE (%)" },
  // ];

  // const handleResetFilters = async () => {
  //   setLoading(true);
  //   setTableLoading(true);
  //   // const newCapCapt = JSON.stringify(['SMALL_CAP', 'MID_CAP', 'LARGE_CAP', 'MEGA_CAP']).replace(/\"/g, "");
  //   // await _getWideScreenerMetrics(newCapCapt, []).then((d) => {
  //   setShowingResults(_screenerMetrics?.length);
  //   // setTableMetrics(_screenerMetrics);
  //   setLoading(false)
  //   setTableLoading(false);
  //   setTableCols([defaultScreenerTableCols[0], defaultScreenerTableCols[1], defaultScreenerTableCols[2], defaultScreenerTableCols[3], defaultScreenerTableCols[4], defaultScreenerTableCols[5], defaultScreenerTableCols[6], defaultScreenerTableCols[7], defaultScreenerTableCols[8],]);
  //   setConditions([]);
  //   setSelectedOptions([]);
  //   setSelected([]);
  //   // })
  // }

  const handleDownload = () => {
    handleMenuClose()
    if (isPremium) {
      downloadCSV(
        screenerMetrics?.sort((a, b) => {
          return b?.MKTCAP - a?.MKTCAP;
        }),
        tableCols,
        `Screener Table`,
        true
      );
    } else {
      setBanner(true)
    }
  };

  const handleExited = () => {
    setUserUpdatedPreset(null)
    setUserDeletedPreset(null)
  };

  useEffect(() => {
    getScreeners('AND', formula)
    getScreenersCount('AND', formula)
  }, [formula, first, offset])

  useEffect(() => {
    if (presetCriteria) {
      setInputText(presetCriteria?.replace(/`([^`]+)`/g, (match, p1) => {
        const replacement = options.find(item => item.aggCode === p1);
        return replacement ? replacement.shortName : match;
      }))
    } else {
      setInputText("")
    }
  }, [presetCriteria])

  useEffect(() => {
    setColumnGroups(mainHeadCols)
  }, [_screenerMetrics])

  return (
    <div className="stock-screener-body sum-section">
      <Container maxWidth="xxl" sx={{ p: '0 !important' }}>
        <Box component="div" className="row sum-r s-screen" sx={{}}>
          <AppBar position="static"
            sx={{
              zIndex: 999, top: '1.3rem',
              // p: 1, pb: 1.5, borderRadius: '5px',
              bgcolor: themeMode === 'dark' ? 'background.default' : '#f8f9fa',
              // boxShadow: '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%)'
              boxShadow: 'inset 0px -8px 24px rgba(214, 227, 255, 0.26)'
            }} elevation={0}
          >
            <Container maxWidth="xl">
              <Box component="nav"
                className="bread-container"
                sx={{
                  mt: 1, padding: '8px 8px 8px 0', borderRadius: '5px',
                }}>
                <Breadcrumbs>
                  <Link prefetch={false} color="inherit" href={`${dataConstants.NAVS.HOME}`} >
                    <StyledBreadcrumb
                      label="Home"
                      icon={<HomeRoundedIcon sx={{ '&.MuiChip-icon': { color: 'text.very_light_desc', fontSize: '1.1rem' }, color: 'text.link' }} fontSize="small" />}
                      sx={{ color: 'text.very_light_desc', fontSize: '.78rem', cursor: 'pointer', '& .MuiChip-label': { pr: 0, lineHeight: 1 }, '& .MuiChip-icon': { ml: 0 } }}
                    />
                  </Link>
                  <Link prefetch={false} color="inherit" href={`/stock-screener`} >
                    <StyledBreadcrumb
                      label={`Stock Screener`}
                      className={'bread-bg-blue'}
                      sx={{ color: 'text.very_light_desc', fontSize: '.78rem', '& .MuiChip-label': { p: 0, lineHeight: 1 } }}
                    />
                  </Link>
                  <StyledBreadcrumb
                    label={`Guide`}
                    className={'bread-bg-blue'}
                    sx={{ fontSize: '.78rem', '& .MuiChip-label': { p: 0, lineHeight: 1 } }}
                  />
                </Breadcrumbs>
              </Box>
              <Box sx={{ mb: .7, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box sx={{ mb: 1 }}>
                  <Typography color="primary" variant="h1" sx={{ mr: 2, fontWeight: 500, fontSize: '1.25rem', lineHeight: '1.6', letterSpacing: '0.0075em', }}>Guide on how to build stock screeners</Typography>
                  <Typography variant='h1' component="p" sx={{ fontSize: '.9rem', color: 'text.very_light_desc' }}>Creating and saving custom stock screeners: a comprehensive guide.</Typography>
                </Box>
              </Box>
            </Container>
          </AppBar>
          <Container maxWidth="xl" sx={{ width: '100%', '& .screener-wrapper': { overflowY: 'scroll', scrollBehavior: "smooth" }, mb: '7rem' }}>
            <Grid container spacing={{ xs: 4, md: 7 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ mb: '2.5rem !important', mt: '.5rem !important' }}>
              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <Box component="div" sx={{}}>
                  <Typography component="p" sx={{ fontSize: '1rem', color: 'hsl(235deg 59.62% 21.27%)', fontWeight: 600, mb: 2 }}>Step 1 - New Screen:</Typography>
                  <Typography component="p" sx={{ fontSize: '.875rem', color: 'text.very_light_desc' }}>
                    To make your own screen, start by clicking on the "+" icon labeled "New Screen" in the top right corner.
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <Box component="div" sx={{ border: '1px solid hsl(235deg 59.62% 21.27%)', borderRadius: '12px', '& img': { borderRadius: '12px', } }}>
                  <Image
                    src={"/images/components/screener/step1.gif"}
                    alt="Customize Query"
                    width={300}
                    height={157}
                    layout="responsive"
                    quality={100}
                  />
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={{ xs: 4, md: 7 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ my: '2.5rem !important' }}>
              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <Box component="div" sx={{}}>
                  <Typography component="p" sx={{ fontSize: '1rem', color: 'hsl(235deg 59.62% 21.27%)', fontWeight: 600, mb: 2 }}>Step 2 - Customize Query:</Typography>
                  <Typography component="p" sx={{ fontSize: '.875rem', color: 'text.very_light_desc' }}>
                    Customize your query or establish your own criteria based on your needs. Feel free to formulate any equation that suits your preferences.
                    <br />
                    <br />
                    <i>
                      <b>Tip: </b><br />Utilize any existing screen as a reference and adjust its query to your liking. You can explore our preset screens at:&nbsp;
                      <Link underline="hover" href="/stock-screener">www.grufity.com/stock-screener/</Link>
                    </i>
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <Box component="div" sx={{ border: '1px solid hsl(235deg 59.62% 21.27%)', borderRadius: '12px', '& img': { borderRadius: '12px', } }}>
                  <Image
                    src={"/images/components/screener/step2.gif"}
                    alt="Save Query"
                    width={300}
                    height={157}
                    layout="responsive"
                    quality={100}
                  />
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={{ xs: 4, md: 7 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ my: '2.5rem !important' }}>
              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <Box component="div" sx={{}}>
                  <Typography component="p" sx={{ fontSize: '1rem', color: 'hsl(235deg 59.62% 21.27%)', fontWeight: 600, mb: 2 }}>Step 3 - Save Query:</Typography>
                  <Typography component="p" sx={{ fontSize: '.875rem', color: 'text.very_light_desc' }}>
                    Now, simply save your query to avoid the need for rebuilding it. This includes saving the table columns and their order, ensuring efficient time management.
                    <br />
                    <br />
                    To save your screen, click on the "Save Screen" button located below the query builder, next to the run button.
                    <br />
                    <br />
                    Upon clicking the "Save Screen" button, a popup will appear, allowing you to name the screen.
                    Additionally, you can provide a description to quickly distinguish the screen from your list later on.
                    <br />
                    <br />
                    <i>
                      <b>Note:</b>&nbsp;Remember, the screens you save are private and not visible to the public.
                    </i>
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <Box component="div" sx={{ border: '1px solid hsl(235deg 59.62% 21.27%)', borderRadius: '12px', '& img': { borderRadius: '12px', } }}>
                  <Image
                    src={"/images/components/screener/step3.gif"}
                    alt="Add to Watchlist"
                    width={300}
                    height={157}
                    layout="responsive"
                    quality={100}
                  />
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={{ xs: 4, md: 7 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ my: '2.5rem !important' }}>
              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <Box component="div" sx={{}}>
                  <Typography component="p" sx={{ fontSize: '1rem', color: 'hsl(235deg 59.62% 21.27%)', fontWeight: 600, mb: 2 }}>Step 4 - Add to Watchlist:</Typography>
                  <Typography component="p" sx={{ fontSize: '.875rem', color: 'text.very_light_desc' }}>
                    Furthermore, you have the option to save filtered stocks to your watchlist and monitor them closely.
                    <br />
                    <br />
                    To save a ticker to your watchlist, simply click on the plus button associated with each ticker.
                    <br />
                    Upon clicking, a list of your previous watchlists will appear, allowing you to select and add them to your desired watchlist.
                    <br />
                    <br />
                    Alternatively, if you wish to create a new watchlist, you can do so by clicking on "+ New Watchlist" in the popup window.
                    <br />
                    <br />
                    <i>
                      <b>Note:</b>&nbsp;If you haven't created any watchlists, there's a default watchlist named "My Watchlist" available where you can add your tickers.
                      <br />
                      You can access and view all your watchlists at: <Link underline="hover" href="/watchlists">www.grufity.com/watchlists/</Link>
                    </i>
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <Box component="div" sx={{ border: '1px solid hsl(235deg 59.62% 21.27%)', borderRadius: '12px', '& img': { borderRadius: '12px', } }}>
                  <Image
                    src={"/images/components/screener/step4.gif"}
                    alt="Manage Table Columns"
                    width={300}
                    height={157}
                    layout="responsive"
                    quality={100}
                  />
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={{ xs: 4, md: 7 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ my: '2.5rem !important' }}>
              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <Box component="div" sx={{}}>
                  <Typography component="p" sx={{ fontSize: '1rem', color: 'hsl(235deg 59.62% 21.27%)', fontWeight: 600, mb: 2 }}>Step 5 - Manage Table Columns:</Typography>
                  <Typography component="p" sx={{ fontSize: '.875rem', color: 'text.very_light_desc' }}>
                    You can manage the table columns by clicking on the "<ViewColumnRoundedIcon sx={{ fontSize: '1.1rem', verticalAlign: 'middle' }} />" button, which will prompt a popup displaying all available metrics that you can add to your filtered screener.
                    <br />
                    <br />
                    There are approximately 90 metrics to choose from. After selecting the desired metrics from the popup, click on the "Save Changes" button located at the top right corner within the popup to confirm your selections.
                    <br />
                    <br />
                    Once saved, you will have all your chosen metrics displayed.
                    <br />
                    <br />
                    <i>
                      <b>Tip:</b>&nbsp;To arrange the table columns as per your preference, simply drag and drop them to the desired position. You can also rearrange columns within the popup by dragging them up and down to arrange them accordingly.
                    </i>
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <Box component="div" sx={{ border: '1px solid hsl(235deg 59.62% 21.27%)', borderRadius: '12px', '& img': { borderRadius: '12px', } }}>
                  <Image
                    src={"/images/components/screener/step5.gif"}
                    alt="Download"
                    width={300}
                    height={157}
                    layout="responsive"
                    quality={100}
                  />
                </Box>
              </Grid>
            </Grid >
            <Grid container spacing={{ xs: 4, md: 7 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ my: '2.5rem !important' }}>
              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <Box component="div" sx={{}}>
                  <Typography component="p" sx={{ fontSize: '1rem', color: 'hsl(235deg 59.62% 21.27%)', fontWeight: 600, mb: 2 }}>Step 6 - Download:</Typography>
                  <Typography component="p" sx={{ fontSize: '.875rem', color: 'text.very_light_desc' }}>
                    If you wish to export the screener as a CSV file, simply click on the "<FileDownloadRoundedIcon sx={{ fontSize: '1.1rem', verticalAlign: 'middle' }} />" button, and then you can rename the CSV file as needed.
                    <br />
                    <br />
                    <i>
                      <b>Note:</b>&nbsp;If you do not see the popup, please check your browser settings and ensure that popups are enabled for "Grufity" to avoid issues in the future.
                      <br />
                      <br />
                      Grufity is a website without advertisements, so you can adjust the popup settings for our site from "blocked" to "ask" without hesitation.
                    </i>
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <Box component="div" sx={{ border: '1px solid hsl(235deg 59.62% 21.27%)', borderRadius: '12px', '& img': { borderRadius: '12px', } }}>
                  <Image
                    src={"/images/components/screener/step6.gif"}
                    alt="Description of your GIF"
                    width={300}
                    height={157}
                    layout="responsive"
                    quality={100}
                  />
                </Box>
              </Grid>
            </ Grid>
          </Container>
        </Box >
      </Container >
    </div >
  );
}

export async function getStaticProps({ params, tabCode = "SCREEN", preview = false, type = "screen", _ = '' }) {
  const first = 100; const offset = 1; const andor = 'AND';
  const { getScreens } = await _getScreens("") || {};
  const meta_tags = (await getPageMetaTags(`/stock-screener`, false)) || {}
  const { getMetaTags } = meta_tags || {}
  return {
    props: {
      // _screenerMetrics: metrics?.getWideScreenerMetricsV3 || null,
      // _screenerMetricsCount: metricsListCount?.getWideScreenerMetricsCountV3 || null,
      // sectors,
      // chart_theme,
      screens: getScreens || [],
      meta_tags: getMetaTags?.tags || null
    },
    revalidate: dataConstants.REVALIDATE_IN.DEFAULT_HOURS,
    // notFound: process.env.NEXT_PUBLIC_URL === 'https://dev.grufity.com' ? false : true,
  }
}


export default ScreenerPage;
